// Comment about functionality

SPACES.ObjControl = (function ($) {
  function ObjControl () {
    this.$controlElement = $('[data-spaces-control="apply-interstitial"]')
  }

  ObjControl.prototype.init = function () {
    this.$controlElement.on('click', function (e) {
			// Handle the click event for the apply interstitial
			e.preventDefault()
			$('[data-spaces-control="apply-interstitial-confirm"]').attr('href', $(this).data('spaces-apply-url'))
			// open the interstitial
			SPACES.spacesModal.open('[data-spaces-modal="spaces-apply-interstitial"]')
    })
  }

  return ObjControl
})(jQuery)

document.addEventListener('spaces_init', function (e) {
  // Hook into the main SPACES init
  SPACES.objControl = new SPACES.ObjControl()
  SPACES.objControl.init()
})

document.addEventListener('spaces_tab', function (e) {
  // Run init after AJAX tab switch
  SPACES.objControl = new SPACES.ObjControl()
  SPACES.objControl.init()
})
